import { useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import { ModuleDashboardPage } from '../../../shared/components/index.js';
import { fetchProjectsDashboard } from '../services/projectsService.js';

const SECTIONS = [
  { id: 'stockProyecto', chartKey: 'stockProyecto', title: 'Stock por proyecto' },
  { id: 'mixEstados', chartKey: 'mixEstados', title: 'Disponibles, reservadas y vendidas' },
  { id: 'evolucionStock', chartKey: 'evolucionStock', title: 'Evolución del stock' },
  { id: 'reservasProyecto', chartKey: 'reservasProyecto', title: 'Reservas por proyecto' },
  { id: 'leadsProyecto', chartKey: 'leadsProyecto', title: 'Consultas o leads por proyecto' },
  { id: 'conversionProyecto', chartKey: 'conversionProyecto', title: 'Conversión por proyecto' },
  { id: 'ranking', chartKey: 'ranking', title: 'Ranking de proyectos' },
  { id: 'alertas', type: 'alerts', title: 'Alertas de inventario' },
  { id: 'tabla', type: 'table', title: 'Proyectos' }
];

export default function ProyectosPage() {
  const { email } = useOutletContext() || {};
  const loadData = useCallback((f) => fetchProjectsDashboard(f), []);
  return (
    <ModuleDashboardPage
      title="Proyectos"
      subtitle="Estado comercial, inventario y rendimiento por proyecto. Caché 30 min (Actualizar fuerza recarga)."
      email={email}
      loadData={loadData}
      filterOpts={{ showExecutive: false, showStatus: true }}
      sections={SECTIONS}
    />
  );
}
